<template>
   <div class="divider relative w-full" :class="itemClass">
  </div>
</template>
<script>
export default {
  name: 'DividerSection',
  props: {
    itemClass: String,
  },
};
</script>
<style scoped>

.divider::after{
    content: '';
    position: absolute;
    background: rgb(51,51,51);
    background: linear-gradient(90deg, rgba(51,51,51,1) 15%, rgba(94,15,11,1) 100%);
    -webkit-clip-path: polygon(0 0, 100% 0, 25% 100%);
    clip-path: polygon(0 0, 100% 0, 25% 100%);
    width: 100%;
    height: 100%;
}
</style>
